// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1jif95FB,.XXxUa8IS,.Lvu47hVN{gap:1rem;max-width:100%}.FPJI9CU3{height:24rem;overflow:hidden}.QzWOkYR\\+{--h:16rem;align-self:flex-start;height:16rem;height:var(--h);-o-object-fit:contain;object-fit:contain}.FPJI9CU3,.QzWOkYR\\+{border:1px solid #c5cde7;border-radius:.5rem;max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_1jif95FB",
	"cropperActions": "XXxUa8IS",
	"cropperContainer": "Lvu47hVN",
	"cropper": "FPJI9CU3",
	"preview": "QzWOkYR+"
};
module.exports = ___CSS_LOADER_EXPORT___;
